// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__crJAJ","link":"styles_link__XzZJ+","image":"styles_image__MG3Fz","hovered":"styles_hovered__YQYMM","hidden":"styles_hidden__Y3KPh"};